import { render, staticRenderFns } from "./phraseModel.vue?vue&type=template&id=5aa302d4&"
import script from "./phraseModel.vue?vue&type=script&lang=js&"
export * from "./phraseModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports